import * as React from 'react';
import { useAppDispatch } from '../../../store';

const triggerStateLoaderIfNeeded = (stateKey: string, options: any = {}) => {
  const dispatch = useAppDispatch();
  const [done, setDone] = React.useState(0);

  React.useEffect(() => {
    switch (stateKey) {
      /*
      case 'state.application.availableBonuses':
        dispatch(getBonusAvailable());
        break;
      */
      default:
        console.error('[triggerStateLoaderIfNeeded] Unknown state key', stateKey);
    }
  }, [stateKey]);

  return done;
};

export default triggerStateLoaderIfNeeded;
